export const GA_CONFIGS = {
  // debug: process.env.NODE_ENV === 'development',
  debug: false,
};

export const GA_TRACKING_ID = 'UA-171041399-1';
